export default {
    //安全证书连接
    itrust:function () {
        switch (location.hostname) {
            case 'itrust.cn' : case 'www.itrust.cn' :       //正式服
            return '//v.itrust.cn';
            default :                       //测试服
                return 'http://test.itrust.cn';
        }
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/url.js